"use client";

import { useMemo, useState } from "react";
import { FUTURE_UPDATES, type RoadmapStatus } from "./updates-data";

const TABS: Array<{ key: RoadmapStatus; label: string }> = [
  { key: "coming-next", label: "Coming next" },
  { key: "planned", label: "Planned" },
  { key: "exploring", label: "Exploring" },
  { key: "done", label: "Shipped" },
];

export function UpdatesTabs() {
  const [activeTab, setActiveTab] = useState<RoadmapStatus>("coming-next");

  const visibleUpdates = useMemo(
    () => FUTURE_UPDATES.filter((item) => item.status === activeTab),
    [activeTab]
  );

  const counts = useMemo(() => {
    const map: Record<RoadmapStatus, number> = {
      done: 0,
      "coming-next": 0,
      planned: 0,
      exploring: 0,
    };
    for (const item of FUTURE_UPDATES) {
      map[item.status] = (map[item.status] ?? 0) + 1;
    }
    return map;
  }, []);

  return (
    <section className="updates-detail-section">
      <div className="updates-tabs" role="tablist" aria-label="Update categories">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            data-active={activeTab === tab.key}
            data-status={tab.key}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            <span className="updates-tab-count">{counts[tab.key] ?? 0}</span>
          </button>
        ))}
      </div>

      <ol className="roadmap-list roadmap-list-full">
        {visibleUpdates.map((item, i) => (
          <li
            key={item.title}
            className={`roadmap-item roadmap-${item.status}`}
          >
            <div className="roadmap-marker" aria-hidden="true">
              <span className="roadmap-index">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="roadmap-body">
              <header className="roadmap-head">
                <span className={`roadmap-status status-${item.status}`}>
                  <span className="roadmap-status-dot" aria-hidden="true" />
                  {item.statusLabel}
                </span>
                <span className="roadmap-eta">{item.eta}</span>
                {item.date && (
                  <span className="roadmap-date">{item.date}</span>
                )}
              </header>
              <h2>{item.title}</h2>
              <p>{item.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
